angular.module('gc.custom-on-change', [])

// https://stackoverflow.com/a/19647381/505836
.directive('customOnChange', function() {
  return {
    restrict: 'A',
    link: function (scope, element, attrs) {
      var onChangeHandler = scope.$eval(attrs.customOnChange);
      element.on('change', function(event) {
        onChangeHandler(event);
        element.val('');
      });
      element.on('$destroy', function() {
        element.off();
      });
    }
  };
})

